import { syncRowNotes } from "./candidate_row_sync";

let bound = false;

const csrfToken = (): string =>
  (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement | null)?.content || "";

const readText = (r: Response): Promise<string> =>
  r.ok && !r.redirected ? r.text() : Promise.reject(new Error(`HTTP ${r.status}`));

function applyLog(wrap: HTMLElement, log: HTMLElement, html: string): void {
  log.outerHTML = html;
  const count = wrap.querySelector<HTMLElement>(".notes-log")?.querySelectorAll(".note-item").length ?? 0;
  syncRowNotes(wrap.dataset.bpId || "", count > 0);
  $("#notes-cnt").text(count);
  // the call-session card has its own counter, outside the drawer
  const cardCount = wrap.closest("[data-call-card]")?.querySelector<HTMLElement>("[data-notes-count]");
  if (cardCount) cardCount.textContent = String(count);
}

const escapeHtml = (text: string): string =>
  text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

// A note input's body as HTML: the drawer's summernote editor, or a plain textarea
// (`data-plain-note`, the call card) whose text is escaped with its line breaks kept.
export function readNoteInput(input: HTMLTextAreaElement): string {
  if (input.dataset.plainNote !== undefined) {
    const text = input.value.trim();
    return text ? escapeHtml(text).replace(/\r?\n/g, "<br>") : "";
  }

  const $input = $(input);
  return $input.summernote("isEmpty") ? "" : String($input.summernote("code") || "");
}

function resetNoteInput(input: HTMLTextAreaElement): void {
  if (input.dataset.plainNote !== undefined) input.value = "";
  else $(input).summernote("reset");
}

export function initCandidateNotesLog(): void {
  if (bound) return;
  bound = true;

  document.addEventListener("click", (e) => {
    const btn = (e.target as HTMLElement).closest<HTMLElement>("[data-add-note-btn]");
    if (!btn) return;
    e.preventDefault();

    const wrap = btn.closest<HTMLElement>("[data-notes]");
    if (!wrap) return;

    const url = wrap.dataset.notesUrl;
    const input = wrap.querySelector<HTMLTextAreaElement>("[data-note-input]");
    const log = wrap.querySelector<HTMLElement>(".notes-log");
    if (!url || !input || !log) return;

    const body = readNoteInput(input);
    if (!body) return;

    const form = new FormData();
    form.append("body", body);

    btn.setAttribute("disabled", "disabled");
    fetch(url, {
      method: "POST",
      headers: { "X-CSRF-Token": csrfToken(), "X-Requested-With": "XMLHttpRequest", Accept: "text/html" },
      body: form,
    })
      .then(readText)
      .then((html) => {
        applyLog(wrap, log, html);
        resetNoteInput(input);
      })
      .catch(() => {
        /* leave input intact on failure */
      })
      .finally(() => btn.removeAttribute("disabled"));
  });

  document.addEventListener("click", (e) => {
    const btn = (e.target as HTMLElement).closest<HTMLElement>("[data-remove-note-btn]");
    if (!btn) return;
    e.preventDefault();

    const wrap = btn.closest<HTMLElement>("[data-notes]");
    const log = wrap?.querySelector<HTMLElement>(".notes-log");
    const url = btn.dataset.noteUrl;
    if (!wrap || !log || !url) return;
    if (!window.confirm("Delete this note?")) return;

    btn.setAttribute("disabled", "disabled");
    fetch(url, {
      method: "DELETE",
      headers: { "X-CSRF-Token": csrfToken(), "X-Requested-With": "XMLHttpRequest", Accept: "text/html" },
    })
      .then(readText)
      .then((html) => applyLog(wrap, log, html))
      // The button is gone with the swapped-in log on success, so only restore it here.
      .catch(() => btn.removeAttribute("disabled"));
  });
}
